import { useState, useEffect } from 'react';
import styles from './Tutor.module.css';
import InstitucionImage from './images/Institucion.png';
import BecasImage from './images/becas.png';
import CarrerasImage from './images/carrera-profesional.png';
import { useNavigate } from 'react-router-dom';

const Tutor = () => {
    const navigate = useNavigate();
    const [isMenuActive, setIsMenuActive] = useState(false);

    const navigateTo = (route) => {
        navigate(route);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            const menu = document.getElementById('menu');
            const menuToggle = document.getElementById('menu-toggle');
            
            if (menu && menuToggle) {
                const isClickInsideMenu = menu.contains(event.target);
                const isClickOnToggle = menuToggle.contains(event.target);
                
                if (!isClickInsideMenu && !isClickOnToggle) {
                    setIsMenuActive(false);
                }
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    return (
        <div className={styles.tutorContainer}>
            <section className={styles.introSection}>
                <h1> Explora el futuro académico de tu hijo </h1>
                <p>
                    Apoya a tu hijo en la elección de su carrera y universidad con la ayuda de esta plataforma educativa.
                </p>
            </section>

            <section id="pasos" className={styles.stepsSection}>
                <h2 className={styles.stepsTitle}>
                    Guía para ayudar a tu hijo en la elección de su futuro académico
                </h2>

                <div className={styles.stepsContainer}>
                    <a href="" className={styles.stepLink}>
                        <div className={styles.step} onClick={() => navigateTo('/areasProfesionales')}>
                            <img 
                                src={InstitucionImage} 
                                alt="Explora opciones de carrera"
                                className={styles.stepImage}
                            />
                            <h3 className={styles.stepTitle}>
                                Explora áreas profesionales y carreras
                            </h3>
                            <p className={styles.stepText}>
                                Descubre junto a tu hijo las áreas de estudio y carreras que se alinean con sus intereses y talentos, ayudándole a identificar su camino ideal.
                            </p>
                        </div>
                    </a>

                    <a href="" className={styles.stepLink}>
                        <div className={styles.step} onClick={() => navigateTo('/directorioUniversidades')}>
                            <img 
                                src={CarrerasImage}
                                alt="Directorio de universidades"
                                className={styles.stepImage}
                            />
                            <h3 className={styles.stepTitle}>
                                Encuentra universidades adecuadas
                            </h3>
                            <p className={styles.stepText}>
                                Accede a un directorio completo de universidades y elige las instituciones que mejor se ajusten a sus metas académicas y necesidades geográficas.
                            </p>
                        </div>
                    </a>

                    <a href="" className={styles.stepLink}>
                        <div className={styles.step} onClick={() => navigateTo('/becasVigentes')}>
                            <img 
                                src={BecasImage} 
                                alt="Becas"
                                className={styles.stepImage}
                            />
                            <h3 className={styles.stepTitle}>
                                Accede a información sobre becas
                            </h3>
                            <p className={styles.stepText}>
                                Investiga las becas y apoyos financieros disponibles para construir juntos un plan hacia una educación universitaria sin barreras.
                            </p>
                        </div>
                    </a>
                </div>
            </section>
        </div>
    );
};

export default Tutor;